import Select from 'Components/Select';
import Label from 'Components/Label';
import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';

export const themeOptions = [
	...Object.keys(eFormGTB.themes).map(key => ({
		label: eFormGTB.themes[key],
		value: key,
	})),
];

const ThemeSelect = ({
	onChange,
	value,
	title = __('Select a theme', 'ipt_fsqm'),
	...selectProps
}) => (
	<Label title={title}>
		<Select
			onChange={onChange}
			options={themeOptions}
			value={value}
			{...selectProps}
		/>
	</Label>
);
ThemeSelect.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.objectOf(PropTypes.string),
};

ThemeSelect.defaultProps = {
	value: null,
};

export default ThemeSelect;
